
import { Separator } from "@/components/ui/separator";

const Imprint = () => {
  return (
    <div className="max-w-4xl mx-auto font-poppins-regular">
      <h1 className="text-3xl font-poppins-bold mb-6">Impresszum</h1>
      <Separator className="mb-8" />

      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">Szolgáltató adatai</h2>
        <div className="space-y-2 text-gray-700">
          <p><strong>Cégnév:</strong> Ementin Kft.</p>
          <p><strong>Székhely:</strong> 1141 Budapest, Szugló utca 125/G A ép. I. em. 103.</p>
          <p><strong>Cégjegyzékszám:</strong> 01-09-920783</p>
          <p><strong>Adószám:</strong> 14806603-2-42</p>
        </div>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">Elérhetőségek</h2>
        <div className="space-y-2 text-gray-700">
          <p><strong>Telefonszám:</strong> +36 1 618 4809</p>
          <p><strong>E-mail cím:</strong> info@medihub.hu</p>
          <p><strong>Weboldal:</strong> www.medihub.hu</p>
        </div>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">Tárhelyszolgáltató adatai</h2>
        <div className="space-y-2 text-gray-700">
          <p><strong>Cégnév:</strong> Ementin Kft.</p>
          <p><strong>Székhely:</strong> 1141 Budapest, Szugló utca 125/G A ép. I. em. 103.</p>
          <p><strong>E-mail cím:</strong> info@medihub.hu</p>
          <p><strong>Telefonszám:</strong> +36 1 618 4809</p>
        </div>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">Tevékenységi kör</h2>
        <div className="space-y-2 text-gray-700">
          <p>Fő tevékenység: Információ-technológiai szolgáltatás, egészségügyi eseménymenedzsment platform</p>
          <p>A MediHub egy online platform, amely lehetővé teszi az egészségügyi szakemberek számára, hogy megtalálják, meghirdessék és részt vegyenek szakmai eseményeken, konferenciákon és továbbképzéseken.</p>
        </div>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">Nyilvántartó hatóság</h2>
        <div className="space-y-2 text-gray-700">
          <p>Fővárosi Törvényszék Cégbírósága</p>
        </div>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">Szakmai kamarai tagság</h2>
        <div className="space-y-2 text-gray-700">
          <p>Budapesti Kereskedelmi és Iparkamara</p>
          <p>Magyar Egészségügyi Szakdolgozói Kamara (partnerszervezet)</p>
        </div>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">Jogszabályi megfelelés</h2>
        <div className="space-y-2 text-gray-700">
          <p>A webhely megfelel az Európai Unió és Magyarország vonatkozó jogszabályainak, beleértve az általános adatvédelmi rendeletet (GDPR) és az elektronikus kereskedelmi szolgáltatások szabályozását.</p>
        </div>
      </section>

      <div className="mt-8 text-sm text-gray-500">
        <p>Utolsó frissítés: 2024. július 10.</p>
      </div>
    </div>
  );
};

export default Imprint;
